<script>
export default {
	name: 'MobileFilterBtn',
	methods: {
		toggleDrawer() {
			this.$emit('toggleDrawer')
		},
	},
}
</script>

<template>
	<div>
		<v-bottom-navigation grow fixed>
			<Button @click="toggleDrawer" class="ml-0 pl-0" text plain :ripple="false">
				<v-icon> mdi-filter </v-icon>
				FILTRAR/ORDENAR
			</Button>
		</v-bottom-navigation>
	</div>
</template>
